import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, search, nullsafe, assertUnreachable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";


export interface Props {
    value: models.FirmaModel;
    onChange?: (x: models.FirmaModel) => void;
}

export interface Vector2 { x: number, y: number }
function toSignaturePad(value: models.FirmaModel): Vector2[][] {
    return value.Segmentos.map(x => x.Puntos.map(punto => ({ x: punto.X, y: punto.Y })));
}
function fromSignaturePad(value: Vector2[][]): models.FirmaModel {
    return {
        Segmentos: value.map<models.SegmentoFirmaModel>(x => ({
            Puntos: x.map(punto => ({ X: punto.x, Y: punto.y }))
        }))
    };
}

/**Componente editor de un FirmaModel */
export class FirmaComponent extends React.PureComponent<Props> {
    render() {
        return (
            <div>
                <kea.SignaturePad
                    value={toSignaturePad(this.props.value)}
                    onChange={val => this.props.onChange && this.props.onChange(fromSignaturePad(val))}
                    readonly={this.props.onChange == null}
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeappZE/entrega/finalizar/firma.tsx